<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title>refresh</title>
        <path d="M23.5 18c0 4.418-3.582 8-8 8s-8-3.582-8-8c0-4.085 3.917-6.595 8-6.951v4.951l10-7v-1l-10-8v5.042c-7.347 0.432-14 5.561-14 12.958 0 7.732 6.268 14 14 14s14-6.268 14-14h-6z"></path>
    </svg>
</template>

<script>
export default {
    name: "Reload",
};
</script>

<style scoped>
svg {
    fill: #757575;
}
</style>
